import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import UploadCpdButton from "./Components/UploadCpdButton";
import Buttons from "../../../components/ui/button/Buttons";
import FormCreator from "../../../components/Forms/FormCreator";
import {
  UploadCpdSearchFormData,
} from "./dataFile/UploadCpdSearchForm.Data";
import { useGetUploadedCPDListMutation } from "../../../app/services/CPD/CPDApi";
import UploadCpdDataGrid from "./Components/UploadCpdDataGrid";

const CpdSelectionContext = createContext();
export const useCpdSelection = () => useContext(CpdSelectionContext);

const UploadCpd = () => {
  const [contextData, setContextData] = useState({
    selectedIds: [],
  });

  const contextValue = {
    contextData,
    setContextData: (data) => setContextData(data),
  };
  const [uploadCPDSearchFormData, setUploadCPDSearchFormData] = useState(
    UploadCpdSearchFormData
  );
  const uploadCPDSearchFormRef = useRef();

  const [dataSource, setDataSource] = useState();
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    endPage: 100,
    searchText: "",
    eventName: "",
    totalCount: 0,
  });

  const [getCpdList, { isSuccess, isLoading, data: cpdListResponse }] =
    useGetUploadedCPDListMutation();

  useEffect(() => {
    if (!isLoading && isSuccess && cpdListResponse) {
      setPaginationRequest({
        ...paginationRequest,
        totalCount: cpdListResponse.totalCount,
      });
      setDataSource(cpdListResponse?.itemList);
    }
  }, [isLoading, isSuccess, cpdListResponse]);

  const handleSearch = () => {
    if (!uploadCPDSearchFormRef.current) {
      return;
    }
    const formData = uploadCPDSearchFormRef.current.getFormData();
    const updatedPaginationRequest = {
      pageNo: 1,
      pageSize: 20,
      endPage: 100,
      searchText: formData.searchText || "",
      searchByEventName: formData.eventName || "",
    };
    setPaginationRequest(updatedPaginationRequest);
    getUploadedCpdList(updatedPaginationRequest);
  };

  const handleClear = () => {
    const updatedForm = { ...uploadCPDSearchFormData };
    updatedForm.initialState = {
      SarchText: null,
      eventName: null,
    }
    const paginationRequests = ({
      ...paginationRequest,
      pageNo: 1,
      pageSize: 20,
      endPage: 100,
      searchText: null,
      searchByEventName: null,
      totalCount: 0,
    });
    setPaginationRequest(prev => { return { ...prev, ...paginationRequests } });
    setUploadCPDSearchFormData(updatedForm);
    getCpdList(paginationRequests);
  };

  const getUploadedCpdList = (req) => {
    getCpdList({ ...paginationRequest, ...req });
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    getUploadedCpdList({
      ...paginationRequest,
      pageNo: pageNumber,
      pageSize: pageSize,
    });
  };

  return (
    <CpdSelectionContext.Provider value={contextValue}>
      <div className="container-fluid">
        <div className="row d-flex justify-content-between">
          <div className='col-lg-4 mt-4'>
            <UploadCpdButton getUploadedCpdList={getUploadedCpdList} />
          </div>
          <FormCreator
            ref={uploadCPDSearchFormRef}
            {...uploadCPDSearchFormData}
          />
          <div className="d-flex align-items-center justify-content-end mt-4" style={{ gap: "10px" }}>
            <div className="">
              <Buttons
                buttonText="Search"
                buttonTypeClassName="success-btn"
                onClick={handleSearch}
              />
            </div>
            <div className="">
              <Buttons
                buttonText="Clear"
                buttonTypeClassName="success-btn"
                onClick={handleClear}
              />
            </div>
          </div>
          <UploadCpdDataGrid
            dataSource={dataSource}
            isLoading={isLoading}
            paginationRequest={paginationRequest}
            onPageChange={handlePageChange}
            getUploadedCpdList={getUploadedCpdList}
          />
        </div>
      </div>
    </CpdSelectionContext.Provider>
  );
};

export default UploadCpd;
